export const userStore = {
  namespace: false,
  state: { userId: "", userNm: "", userInfo: {}, storeCode: "", sessionStauts: false },
  getters: {
    getUserInfo(state: any) {
      return state.userInfo;
    },
    getSessionStauts(state: any) {
      return state.sessionStauts;
    },
  },
  mutations: {
    setUserInfo(state: any, value: any) {
      state.userId = value.EMP_NO;
      state.userNm = value.EMP_NAME;
      state.storeCode = value.STR_CODE;
      //   state.storeName = value.STR_NAME;
      state.sessionStauts = true;
      state.userInfo = value;
      //sessionStorage.setItem("rol_cd", value.rol_cd);
    },
    setSessionStatus(state: any, value: boolean) {
      state.sessionStauts = value;
    },
  },
};
export default userStore;
